const ro = {
  common: {
    language: 'Limba',
    romanian: 'Romana',
    english: 'Engleza',
  },
  navbar: {
    pages: 'Pagini',
    notifications: 'Notificari',
    markAllRead: 'Marcheaza toate ca citite',
    loadMore: 'Incarca mai multe',
    hey: 'Salut',
    switchAccount: 'Schimba contul',
    noLinkedAccounts: 'Nu exista conturi conectate',
    linkAnotherAccount: 'Conecteaza alt cont',
    profileSettings: 'Setari profil',
    changePassword: 'Schimba parola',
    logout: 'Deconectare',
    toggleTheme: 'Comuta tema culorilor',
  },
  sidebar: {
    collapse: 'Restrange meniul',
    expand: 'Extinde meniul',
  },
  routes: {
    mainDashboard: 'Tablou principal',
    orders: 'Comenzi',
    partialOrders: 'Comenzi partiale',
    products: 'Produse',
    editForm: 'Editeaza formular',
    createForm: 'Creeaza formular',
    landingPageBuilder: 'Builder Landing Page',
    editProduct: 'Editeaza produs',
    createProduct: 'Creeaza produs',
    duplicateProduct: 'Duplica produs',
    team: 'Echipa',
    roas: 'ROAS',
    calculator: 'Calculator',
    settings: 'Setari',
    changePassword: 'Schimba parola',
    linkAccount: 'Conecteaza cont',
    acceptLinking: 'Accepta conectarea',
    forbidden: 'Interzis',
    signIn: 'Autentificare',
  },
  signIn: {
    title: 'Autentificare',
    subtitle: 'Introdu emailul si parola pentru autentificare!',
    email: 'Email',
    password: 'Parola',
    submit: 'Autentificare',
    placeholders: {
      email: 'Introdu emailul',
      password: 'Introdu parola',
    },
    errors: {
      failedToLogin: 'Autentificare esuata',
    },
  },
  forbidden: {
    title: 'Acces interzis',
    defaultMessage: 'Nu ai permisiunea sa accesezi aceasta resursa.',
    requested: 'Solicitat',
    goBack: 'Inapoi',
    goDashboard: 'Mergi la dashboard',
  },
  changePassword: {
    title: 'Schimba parola',
    currentPassword: 'Parola curenta',
    newPassword: 'Parola noua',
    confirmNewPassword: 'Confirma parola noua',
    submit: 'Schimba parola',
    placeholders: {
      currentPassword: 'Introdu parola curenta',
      newPassword: 'Introdu parola noua',
      confirmNewPassword: 'Confirma parola noua',
    },
    aria: {
      toggleCurrentPassword: 'Comuta vizibilitatea parolei curente',
      toggleNewPassword: 'Comuta vizibilitatea parolei noi',
      toggleConfirmPassword: 'Comuta vizibilitatea confirmarii parolei',
    },
    messages: {
      passwordsDoNotMatch: 'Parolele nu coincid',
      changedSuccess: 'Parola a fost schimbata cu succes!',
      genericError: 'A aparut o eroare',
    },
  },
  linkAccount: {
    premiumRequired: 'Ai nevoie de cont premium pentru a invita alte conturi.',
    title: 'Conecteaza unul dintre conturile tale',
    inviteeEmail: 'Email invitat',
    sendInvite: 'Trimite invitatia',
    placeholders: {
      email: 'user@example.com',
    },
    messages: {
      failedInvite: 'Trimiterea invitatiei a esuat',
    },
  },
  acceptLink: {
    linked: 'Conectat!',
    failed: 'Acceptarea invitatiei a esuat',
    success: 'Succes!',
    goDashboard: 'Mergi la dashboard',
    oops: 'Ups!',
    home: 'Acasa',
  },
  settings: {
    tabs: {
      general: 'General',
      facebook: 'Facebook',
      tiktok: 'TikTok',
    },
    labels: {
      storeUrl: 'URL magazin WooCommerce',
      thankYouPage: 'Pagina de multumire (OPTIONAL)',
      consumerKey: 'WooCommerce Consumer Key',
      consumerSecret: 'WooCommerce Consumer Secret',
      apiKey: 'Cheie API',
      facebookPixel: 'Facebook Pixel ID (OPTIONAL)',
      conversionToken: 'Conversion API Token (OPTIONAL)',
      tiktokPixel: 'TikTok Pixel (OPTIONAL)',
    },
    placeholders: {
      storeUrl: 'Introdu URL-ul magazinului',
      consumerKey: 'Introdu consumer key',
      consumerSecret: 'Introdu consumer secret',
      facebookPixel: 'Introdu scriptul Facebook Pixel',
      conversionToken: 'Introdu tokenul conversion API',
      tiktokPixel: 'Introdu TikTok pixel',
    },
    tooltips: {
      showApiKey: 'Afiseaza cheia API',
    },
    aria: {
      showApiKey: 'Afiseaza cheia API',
      addRecipient: 'Adauga destinatar',
      removeRecipient: 'Elimina destinatar',
    },
    addEmailRecipients: 'Adauga destinatari email',
    saveSettings: 'Salveaza setarile',
    toast: {
      saved: 'Setarile au fost salvate cu succes',
      failedSave: 'Salvarea setarilor a esuat',
      syncStarted: 'Sincronizarea comenzilor a inceput. Poti parasi aceasta pagina',
      failedSync: 'Sincronizarea comenzilor a esuat',
      maxRecipients: 'Numarul maxim de destinatari email este 2',
      recipientsSaved: 'Destinatarii email au fost salvati cu succes',
      failedRecipients: 'Salvarea destinatarilor email a esuat',
    },
    modal: {
      addRecipients: 'Adauga destinatari email',
      email: 'Email',
      enterEmail: 'Introdu email',
      saveRecipients: 'Salveaza destinatarii',
      cancel: 'Anuleaza',
    },
  },
  team: {
    createEmployee: 'Creeaza angajat',
    editEmployee: 'Editeaza angajat',
    update: 'Actualizeaza',
    save: 'Salveaza',
    cancel: 'Anuleaza',
    table: {
      name: 'Nume',
      email: 'Email',
      permissions: 'Permisiuni',
      actions: 'Actiuni',
    },
    form: {
      name: 'Nume',
      email: 'Email',
      password: 'Parola',
      newPasswordOptional: 'Parola noua (optional)',
      permissions: 'Permisiuni',
    },
    aria: {
      editMember: 'editeaza membru',
      deleteEmployee: 'sterge angajat',
    },
    confirm: {
      deleteEmployee: 'Sigur vrei sa stergi acest angajat?',
    },
    toast: {
      failedFetchEmployees: 'Preluarea angajatilor a esuat',
      failedFetchPermissions: 'Preluarea permisiunilor a esuat',
      employeeUpdated: 'Angajat actualizat',
      employeeCreated: 'Angajat creat',
      saveFailed: 'Salvarea a esuat',
      somethingWrong: 'Ceva nu a mers bine',
      employeeDeleted: 'Angajat sters',
      deleteFailed: 'Stergerea a esuat',
    },
  },
  products: {
    searchProduct: 'Cauta produs',
    searchByName: 'Cauta dupa nume',
    createProduct: 'Creeaza produs',
    openLink: 'Deschide link produs',
    noLink: 'Fara link',
    currencyLei: 'LEI',
    editProduct: 'Editeaza produs',
    duplicateProduct: 'Duplica produs',
    loadingForm: 'Se incarca formularul...',
    editForm: 'Editeaza formular',
    previewForm: 'Previzualizare formular',
    landingBuilder: 'Builder landing',
    deleteProduct: 'Sterge produs',
    showing: 'Afisare',
    of: 'din',
    deleteConfirmationTitle: 'Confirmare stergere',
    deleteConfirmation: 'Sigur vrei sa stergi acest produs?',
    cancel: 'Anuleaza',
    delete: 'Sterge',
    formPreview: 'Previzualizare formular',
    close: 'Inchide',
    messages: {
      noForm: 'Acest produs nu are formular',
    },
    products: 'produse',
    table: {
      name: 'Nume',
      slug: 'Slug (unic)',
      productId: 'ID produs',
      link: 'Link',
      options: 'Optiuni',
      actions: 'Actiuni',
    },
    aria: {
      productLink: 'Link produs',
      actions: 'Actiuni',
    },
  },
  productForm: {
    description: 'Pastreaza detaliile produsului, optiunile de cumparare si integrarile organizate intr-un singur flux.',
    setupProgress: 'Progres configurare',
    step: 'Pas',
    of: 'din',
    previous: 'Inapoi',
    next: 'Urmatorul',
    save: 'Salveaza',
    mode: {
      duplicate: 'Duplicare produs',
      edit: 'Editare produs',
      create: 'Creare produs',
    },
    steps: {
      basics: { title: 'Baza', description: 'Nume, ID-uri si comportament produs' },
      options: { title: 'Optiuni', description: 'Preturi, cantitati si imagini' },
      advanced: { title: 'Avansat', description: 'Culori si ID-uri WooCommerce' },
      review: { title: 'Revizuire', description: 'Confirma inainte de salvare' },
    },
    messages: {
      duplicated: 'Produs duplicat cu succes',
      updated: 'Produs actualizat cu succes',
      created: 'Produs creat cu succes',
    },
  },
  formEditor: {
    mode: {
      edit: 'Editeaza formular',
      create: 'Creeaza formular',
    },
    selected: 'Selectat',
    noThemeSelected: 'Niciun theme selectat',
    chooseCheckoutLook: 'Alege un aspect pentru checkout',
    hideThemes: 'Ascunde teme',
    changeTheme: 'Schimba tema',
    addField: 'Adauga camp',
    addUpsell: 'Adauga upsell',
    saveForm: 'Salveaza formularul',
    themePreset: 'Preset tema',
    pageDescription: 'Configureaza formularul clientului, livrarea, termenii, upsell-urile si tema checkout.',
    themePresetsUnavailable: 'Preseturile de tema nu sunt disponibile momentan pentru acest formular.',
    themePresetsLoadError: 'Preseturile de tema nu au putut fi incarcate momentan.',
    themePresetsEmptyForForm: 'Nu au fost returnate preseturi pentru acest formular.',
    themePresetsEmpty: 'Nu exista preseturi disponibile momentan.',
    loadError: 'Nu am putut incarca acest formular acum.',
    messages: {
      updated: 'Formular actualizat cu succes',
      created: 'Formular creat cu succes',
    },
  },
  landing: {
    pageDescription: 'Editeaza continutul produsului si exporta template-ul JSON Elementor pentru WordPress.',
    save: 'Salveaza',
    saveExport: 'Salveaza si exporta JSON',
    messages: {
      saved: 'Pagina de landing a fost salvata cu succes.',
      exported: 'JSON-ul Elementor a fost exportat cu succes.',
      mediaUploaded: 'Media a fost incarcata cu succes.',
    },
  },
  dashboard: {
    startDate: 'Data inceput',
    endDate: 'Data sfarsit',
    dateRange: 'Interval data',
    ranges: {
      today: 'Astazi',
      yesterday: 'Ieri',
      thisWeek: 'Saptamana aceasta',
      lastWeek: 'Saptamana trecuta',
      thisMonth: 'Luna aceasta',
      lastMonth: 'Luna trecuta',
      thisYear: 'Anul acesta',
      lastYear: 'Anul trecut',
      maximum: 'Maxim',
    },
    period: {
      yesterday: 'ieri',
      dayBeforeYesterday: 'alaltaieri',
      lastWeek: 'saptamana trecuta',
      weekBeforeLastWeek: 'saptamana de dinaintea celei trecute',
      lastMonth: 'luna trecuta',
      monthBeforeLastMonth: 'luna de dinaintea celei trecute',
      lastYear: 'anul trecut',
      yearBeforeLastYear: 'anul de dinaintea anului trecut',
    },
    cards: {
      totalSalesOrders: 'Vanzari totale / Comenzi',
      totalDelivered: 'Total / Comenzi livrate',
      avgOrderValue: 'Valoare medie comanda',
      spend: 'Cheltuiala',
      roas: 'ROAS',
      conversionRate: 'Rata conversie',
      metaTokenExpired: 'Token-ul de acces Meta a expirat. Datele ROAS nu se vor mai actualiza pana cand este inlocuit.',
    },
    table: {
      productName: 'Nume produs',
      totalSales: 'Vanzari totale',
      totalOrders: 'Comenzi totale',
      totalUnits: 'Unitati vandute',
      returnRate: 'Retur %',
    },
    orders: 'comenzi',
    upsells: 'Upsell-uri',
  },
  roas: {
    startDate: 'Data inceput',
    endDate: 'Data sfarsit',
    monthShortcut: 'Luna (scurtatura)',
    saveAll: 'Salveaza tot',
    save: 'Salveaza',
    total: 'Total',
    previous: 'Inapoi',
    next: 'Inainte',
    page: 'Pagina',
    table: {
      day: 'Zi',
      spend: 'Cheltuiala',
      sales: 'Vanzari',
      orders: 'Comenzi',
    },
    messages: {
      maxRange: 'Selecteaza un interval de maximum 31 de zile',
      spendSaved: 'Cheltuiala a fost salvata',
      allSaved: 'Toate cheltuielile au fost salvate',
    },
  },
  orders: {
    title: 'Comenzi',
    delete: 'Sterge',
    sync: 'Sincronizeaza',
    syncing: 'Se sincronizeaza…',
    syncFailedTooltip: 'Sincronizarea a esuat, apasa Sincronizeaza pentru a incerca din nou',
    selectedCount: '{{count}} comenzi selectate',
    toggleColumns: 'Comuta coloane',
    editOrder: 'Editeaza comanda',
    viewUpsells: 'Vezi upsell-uri',
    deleteConfirmationTitle: 'Confirmare stergere',
    deleteConfirmation: 'Sigur vrei sa stergi aceasta inregistrare?',
    bulkDeleteConfirmation: 'Sigur vrei sa stergi cele {{count}} comenzi selectate? Aceasta actiune nu poate fi anulata.',
    bulkSyncConfirmationTitle: 'Confirmare sincronizare',
    bulkSyncConfirmation: 'Sigur vrei sa sincronizezi cele {{count}} comenzi selectate cu WooCommerce?',
    filters: {
      startDate: 'Data inceput',
      endDate: 'Data sfarsit',
      product: 'Produs',
      selectProduct: 'Selecteaza produs',
      allProducts: 'Toate produsele',
      source: 'Sursa',
      selectSource: 'Selecteaza sursa',
      allSources: 'Toate sursele',
      filterSynced: 'Filtru sincronizare',
      allOrders: 'Toate comenzile',
      synced: 'Sincronizate',
      notSynced: 'Nesincronizate',
      riskLevel: 'Nivel risc',
      allRiskLevels: 'Toate nivelurile',
      low: 'Scazut',
      medium: 'Mediu',
      high: 'Ridicat',
      notScored: 'Neevaluate',
      search: 'Cauta',
    },
    table: {
      createdAt: 'Creat la',
      actions: 'Actiuni',
      risk: 'Risc',
      product: 'Produs',
      option: 'Optiune',
      name: 'Nume',
      phone: 'Telefon',
      county: 'Judet',
      city: 'Oras',
      address: 'Adresa',
      total: 'Total',
      status: 'Status',
      synced: 'Sincronizat',
      source: 'Sursa',
      upsell: 'Upsell',
    },
    tooltip: {
      deleteSelected: 'Sterge comenzile selectate',
      syncSelected: 'Sincronizeaza comenzile selectate cu WooCommerce',
      ipBlocked: 'Acest IP este blocat',
      phoneFoundInOrders: 'Acest numar apare in comenzile tale de',
      times: 'ori',
      shortPhone: 'Acest numar are mai putin de 10 cifre',
    },
    aria: {
      visibleColumns: 'Coloane vizibile',
      blockUserTooltip: 'Tooltip blocare utilizator',
      blockedIpTooltip: 'Tooltip IP blocat',
      phoneDuplicates: 'Duplicat numere telefon',
      invalidPhoneTooltip: 'Tooltip telefon invalid',
      viewUpsell: 'vezi upsell',
      actions: 'Actiuni',
      removeUpsell: 'Elimina upsell',
    },
    form: {
      name: 'Nume',
      phone: 'Telefon',
      digits: 'cifre',
      address: 'Adresa',
      city: 'Oras',
      county: 'Judet',
      postalCode: 'Cod postal',
      postalSuggestions: 'Sugestii cod postal',
      status: 'Status',
      option: 'Optiune',
      upsellDetails: 'Detalii upsell',
    },
    status: {
      pending: 'In asteptare',
      cancelled: 'Anulata',
    },
    editOrderAction: 'Editeaza comanda',
    blockIp: 'Blocheaza IP',
    deleteOrder: 'Sterge comanda',
    showing: 'Afisare',
    from: 'din',
    orders: 'comenzi',
    phoneAppearsIn: 'Acest numar de telefon apare in',
    lastOrder: 'Ultima comanda',
    noStatusBreakdown: 'Nu exista detalii pe status.',
    noMorePostalCodes: 'Nu mai exista coduri pentru aceasta adresa',
    loadNextPostalCodes: 'Incarca urmatoarele 3 coduri postale',
    loadMore: 'Incarca mai mult',
    cancel: 'Anuleaza',
    save: 'Salveaza',
    saveStay: 'Salveaza si ramai',
    messages: {
      deleted: 'Comanda stearsa cu succes',
      bulkDeleted: 'Comenzile au fost sterse cu succes',
      bulkDeleteFailed: 'Comenzile nu au putut fi sterse cu succes',
      bulkSynced: 'Comenzile au fost sincronizate cu succes',
      bulkSyncFailed: 'Comenzile nu au putut fi sincronizate cu succes',
      synced: 'Comanda a fost sincronizata cu succes',
      syncFailed: 'Comanda nu a putut fi sincronizata cu succes',
      alreadySyncing: 'Sincronizarea este deja in curs, te rugam asteapta',
      allSelectedSyncing: 'Comenzile selectate sunt deja in curs de sincronizare',
      updated: 'Comanda a fost actualizata cu succes',
      phoneDigits: 'Numarul de telefon trebuie sa aiba cel putin 10 cifre!',
      ipBlocked: 'a fost blocat',
    },
  },
  partials: {
    allProducts: 'Toate produsele',
    showing: 'Afisare',
    of: 'din',
    orders: 'comenzi',
    editPartialOrder: 'Editeaza comanda partiala',
    deleteConfirmationTitle: 'Confirmare stergere',
    deleteConfirmation: 'Sigur vrei sa stergi aceasta comanda partiala?',
    bulkDeleteConfirmation: 'Sigur vrei sa stergi cele {{count}} comenzi partiale selectate? Aceasta actiune nu poate fi anulata.',
    selectedCount: '{{count}} comenzi partiale selectate',
    filters: {
      product: 'Produs',
      selectProduct: 'Selecteaza produs',
      search: 'Cauta',
      submitAttempt: 'Incercare trimitere',
      all: 'Toate',
      attempted: 'Incercat',
      notAttempted: 'Neincercat',
      excludeProducts: 'Exclude produse din lista',
    },
    table: {
      createdAt: 'Creat la',
      actions: 'Actiuni',
      product: 'Produs',
      option: 'Optiune',
      name: 'Nume',
      phone: 'Telefon',
      county: 'Judet',
      city: 'Oras',
      address: 'Adresa',
      shipment: 'Livrare',
      submitAttempt: 'Incercare trimitere',
      phoneExists: 'Telefon existent',
      terms: 'Termeni',
      calls: 'Numar apeluri',
    },
    tooltip: {
      deleteSelected: 'Sterge comenzile partiale selectate',
      shortPhone: 'Acest numar are mai putin de 10 cifre',
      attempted: 'S-a incercat trimiterea',
      notAttempted: 'Nu s-a trimis',
      phoneExists: 'Numarul de telefon exista in comenzi',
      termsAccepted: 'Termeni acceptati',
      termsNotAccepted: 'Termeni neacceptati',
    },
    aria: {
      shortPhone: 'Numar telefon prea scurt',
      actions: 'Actiuni',
      removeUpsell: 'Elimina upsell',
    },
    form: {
      name: 'Nume',
      phone: 'Telefon',
      address: 'Adresa',
      city: 'Oras',
      county: 'Judet',
      option: 'Optiune',
      colors: 'Culori',
      selectColor: 'Selecteaza culoare',
      upsells: 'Upsell-uri',
    },
    delete: 'Sterge',
    editPartial: 'Editeaza partial',
    confirmOrder: 'Confirma comanda',
    addCall: 'Adauga apel',
    deletePartial: 'Sterge partial',
    cancel: 'Anuleaza',
    save: 'Salveaza',
    messages: {
      deletedSelected: 'Partialele au fost sterse!',
      callAdded: 'Apel adaugat!',
      deleted: 'Partial sters!',
      orderConfirmed: 'Comanda confirmata!',
      updated: 'Partial actualizat cu succes!',
      phoneDigits: 'Numarul de telefon trebuie sa aiba cel putin 10 cifre!',
    },
  },
}

export default ro
